<div class="modal-header">
    <h5 class="modal-title">
        <span>Change Report</span>
    </h5>
    <span class="fa fa-close" aria-label="Close" (click)="activeModal.close()"></span>
</div>
<div class="modal-body">
    <concourse-rxr-report [saveToFolder]="saveToFolder" [selectedDepartment]="selectedDepartment" [selectedRoom]="selectedRoom"></concourse-rxr-report>
</div>